import React, { useEffect, useRef } from 'react';
import { shape, string } from 'prop-types';
import { isMobileOnly } from 'react-device-detect';
import Chart from 'chart.js/auto';

function ProjectTimeLineGraph({ schedule }) {
  const colourMapper = {
    design: 'rgb(222, 134, 92)',
    civil: 'rgb(192, 84, 42)',
    carpentry: 'rgb(87, 167, 146)',
    float: 'rgb(145,192,204)',
  };
  const canvasRef = useRef(null);
  useEffect(() => {
    let chartInstance = null;
    if (Object.keys(schedule).length > 0) {
      const labels = Object.keys(schedule.timeline);
      const myChart = new Chart(canvasRef.current, {
        type: 'bar',
        data: {
          startFromZero: false,
          labels,
          display: false,
          width: 10,
          datasets: [
            {
              // barThickness: 40,
              // borderRadius: 10,
              fill: false,
              label: Object.keys(schedule.timeline),
              data: Object.keys(schedule.timeline).map(service => [
                schedule.timeline[service].start,
                schedule.timeline[service].end,
              ]),
              backgroundColor: Object.keys(schedule.timeline).map(service => colourMapper[service]),
              hoverOffset: 4,
              borderRadius: 5,
              borderSkipped: false,
            },
          ],
          // datasets: Object.keys(timeline.timeline).map(service => {
          //   const { start, end } = timeline.timeline[service];
          //   return {
          //     barThickness: 40,
          //     borderRadius: 10,
          //     fill: false,
          //     label: service.toUpperCase(),
          //     data: [start, end],
          //     backgroundColor: colourMapper[service],
          //     borderWidth: 1,
          //   };
          // }),
        },
        options: {
          indexAxis: 'y',
          scales: {
            y: {
              grid: {
                display: false,
              },
              beginAtZero: false,
              display: false,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
        },
      });
      myChart.update();
      chartInstance = myChart;
    }

    return () => {
      chartInstance.destroy();
    };
  }, [schedule]);
  return (
    <div className="project-timeline-graph">
      <div className={`${!isMobileOnly ? 'tw-flex tw-flex-wrap' : 'tw-h-full'}`}>
        <div
          className={`${
            !isMobileOnly
              ? 'tw-w-3/5 tw-justify-center tw-items-center tw-flex tw-pl-4'
              : 'tw-p-4 tw-h-full'
          }`}
        >
          <canvas ref={canvasRef} />
        </div>
        <div className={`${!isMobileOnly ? 'tw-w-2/5 tw-flex tw-flex-col tw-items-center' : ''}`}>
          <div className="chart-legends">
            <ul className="tw-p-4 tw-flex tw-flex-col tw-pb-2">
              {Object.keys(colourMapper).map(item => (
                <li
                  key={item}
                  className="tw-p-2 tw-uppercase tw-text-gray-600 tw-text-sm tw-flex"
                  style={{ fontSize: '12px' }}
                >
                  <div
                    style={{ backgroundColor: colourMapper[item] }}
                    className="tw-w-6 tw-relative tw-h-6 tw-rounded-sm tw-inline-block tw-mr-1"
                  />
                  <div className="text-capitalize">
                    {item.replace(/carpentry/, 'build').replace(/float/, 'contingency')}
                    {item === 'carpentry' && <sup>*</sup>}
                    <span className="tw-ml-1">
                      ({schedule.timeline[item].end - schedule.timeline[item].start}{' '}
                      {schedule.timeline[item].end - schedule.timeline[item].start === 1
                        ? 'week'
                        : 'weeks'}
                      )
                    </span>
                  </div>
                </li>
              ))}
              {isMobileOnly && (
                <li className="text-2-color tw-pl-2 tw-mb-4">
                  * Build includes Carpentry, Painting, Electrical, False Ceiling etc.
                </li>
              )}
            </ul>
          </div>
        </div>
        {!isMobileOnly && (
          <div className="alert alert-warning px-3 py-0 mx-auto" role="alert">
            * Build includes Carpentry, Painting, Electrical, False Ceiling etc.
          </div>
        )}
      </div>
    </div>
  );
}

ProjectTimeLineGraph.propTypes = {
  schedule: shape({ overall: string }),
};

ProjectTimeLineGraph.defaultProps = {
  schedule: { timeline: { overall: 0 } },
};

export { ProjectTimeLineGraph };
